<template lang="html">
  <section class="equity-calculator-number-of-simulations-settings settings">
    <header>
      <h1 class="page-header">Number of simulations (equity calculator)</h1>
    </header>
    <input
      type="number"
      class="form-control input-lg"
      ref="numberOfSimulations"
      v-bind:value="numberOfSimulations"
      step="1000"
    >
    <hr>
    <section class="buttons">
      <button class="btn btn-default btn-lg" v-on:click="isHelpVisible = !isHelpVisible">
        <span v-if="!isHelpVisible">Show help <span class="caret-down"></span></span>
        <span v-if="isHelpVisible">Hide help <span class="caret-up"></span></span>
      </button>
      <button class="btn btn-default btn-lg" v-on:click="reset()">
        Set to default (25,000)
      </button>
      <button class="btn btn-primary btn-lg" v-on:click="save()">
        Save
      </button>
    </section>
    <section v-if="isHelpVisible" class="well">
      <p>By running more simulations, you'll get more accurate results, but it'll take longer. By running fewer simulations, it'll run more quickly, but the results won't be as accurate.</p>
      <p>How long the simulations take depend on the processing speed of the device you're using.</p>
    </section>
  </section>
</template>

<script>
export default {
  name: 'equity-calculator-number-of-simulations-settings',
  data: function () {
    return {
      numberOfSimulations: this.$store.state.account.user.settings.equityCalculator.numberOfSimulations,
      isHelpVisible: false,
    };
  },
  methods: {
    reset: function () {
      let self = this;

      self.$refs.numberOfSimulations.value = 25000;
      setTimeout(function () {
        self.save();
      }, 50);
    },
    save: function () {
      if (Number(this.$refs.numberOfSimulations.value) > 250000) {
        alert("That's too much. It'd probably crash your browser. Try 250,000 or less.");
        return;
      }

      let user = _.cloneDeep(this.$store.state.account.user);
      let self = this;

      user.settings.equityCalculator.numberOfSimulations = this.$refs.numberOfSimulations.value;
      self.$http.put(`${process.env.BASE_API_URL}/user`, { user: user }).then(function (res) {
        self.$store.commit('account/setUser', res.data.user);
        alert('Saved!');
      }).catch(function () {
        alert('Unable to save settings.');
      });
    },
  }
};
</script>

<style lang="scss" scoped>
  @import 'src/assets/settings';
</style>



// WEBPACK FOOTER //
// src/components/settings/equity-calculator/number-of-simulations.vue